// IPL
const _import = name => {
    return resolve => require([`../../views/${name}`], resolve)
}
  
  const IplChild = {
    path: '/IPL',
    component: _import('betting'),
    children: [{
        path: '',
        meta: {
            navShow: false,
            titleHide: true,
            // requireAuth:true
            requireAuth:true
        },
        name: 'IPL',
        component: _import('IPL'),
      },
      {
        path: 'Bet',
        meta: {
          navShow: false,
          titleHide: true,
          // requireAuth: true,
          requireAuth:false
        },
        name: 'Bet',
        component: _import('IPL/Bet'),
      },
      {
        path: 'Record',
        meta: {
          navShow: false,
          titleHide: true,
          // requireAuth: true,
          requireAuth:false
        },
        name: 'Record',
        component: _import('IPL/Record'),
      },
    ]
  }
  
  export default IplChild
  


// WEBPACK FOOTER //
// ./src/pages/build902/router/module/Ipl.js